var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.isShow == true ? 'padding-top: 70px;':''),attrs:{"id":"app"}},[(_vm.isShow == true)?_c('header-view'):_vm._e(),_c('router-view'),(_vm.isShow == true)?_c('footer-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }